import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Clear.svg",
  "use": "Clear.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Clear.svg\"><path d=\"M32.01,8.02A24.001,24.001,0,1,1,8.01,32.0208,24.0009,24.0009,0,0,1,32.01,8.02ZM21.5957,39.594a2.0016,2.0016,0,0,0,2.8308,2.83l7.573-7.5731,7.5842,7.5841a2.0015,2.0015,0,0,0,2.83-2.8306L34.83,32.0207l7.6132-7.613a2.0015,2.0015,0,0,0-2.83-2.83L31.9995,29.19l-7.6019-7.602a2.0016,2.0016,0,0,0-2.8309,2.8306l7.6022,7.602Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol